<template>
    <div
        class="section section--shop c-loading-section"
        v-bind:class="{
            'c-loading-section--loaded': shopLoaded,
            'o-shop--post-load': videoShowing,
        }"
    >
        <div class="container">
            <div class="o-section__max-w">
                <div class="c-shop__filter">
                    <v-select
                        v-model="metal"
                        label="text"
                        value="value"
                        :clearable="false"
                        :options="metals"
                    ></v-select>
                </div>

                <ul class="o-shop-items">
                    <li
                        class="o-shop-items__item"
                        v-for="ring in rings"
                        :key="ring.id"
                        :id="ring.id"
                        @mouseleave="
                            shopItemHoverRemove(
                                ring.id,
                                ring.variations[ring.variationIndex].guid
                            )
                        "
                        @mouseenter="
                            shopItemHover(
                                ring.id,
                                ring.variations[ring.variationIndex].guid
                            )
                        "
                    >
                        <a
                            :href="'/product/' + ring.id"
                            v-on:click="goToDetails($event, ring)"
                            class="o-shop-item"
                        >
                            <div
                                class="o-shop__video"
                                v-for="(variation, index) in ring.variations"
                                :key="variation.guid"
                                v-bind:class="{
                                    'o-shop__video--active':
                                        index == ring.variationIndex,
                                }"
                            >
                                <div class="o-shop-item__image-carousel">
                                    <span
                                        v-show="
                                            variation.videoPlaceholder != null
                                        "
                                    >
                                        <video
                                            oncanplay="this.muted=true"
                                            muted
                                            v-bind:id="
                                                'video-' + variation.guid
                                            "
                                            v-bind:class="{
                                                'js-video-started':
                                                    index ==
                                                    ring.variationIndex,
                                            }"
                                            class="c-shop__video"
                                            loop
                                            v-bind:src="variation.videoSrc"
                                        >
                                            <source type="video/mp4" />
                                        </video>
                                    </span>
                                    <span class="c-loading-block"></span>
                                </div>
                                <h1
                                    class="o-shop-item__title"
                                    v-text="ring.name"
                                ></h1>
                            </div>
                            <h2 class="o-shop-item__price">
                                {{
                                    ring.variations[ring.variationIndex].price[
                                        $store.state.currency
                                    ].formatted
                                }}
                            </h2>
                        </a>
                    </li>
                    <span
                        class="o-shop-items__container"
                        v-show="mobile"
                    ></span>
                </ul>
                <div
                    class="c-2d__pagination c-2d__pagination--shop"
                    v-show="mobile"
                >
                    <span
                        class="c-2d__page-number c-2d__page-number--edge"
                        v-bind:class="{
                            'c-2d__page-number--active': currentIndex == 2,
                            'c-2d__page-number--inactive': currentIndex != 2,
                        }"
                    ></span>
                    <span
                        class="c-2d__page-number c-2d__page-number--center"
                        v-bind:class="{
                            'c-2d__page-number--active': currentIndex == 0,
                            'c-2d__page-number--inactive': currentIndex != 0,
                        }"
                    ></span>
                    <span
                        class="c-2d__page-number c-2d__page-number--edge"
                        v-bind:class="{
                            'c-2d__page-number--active': currentIndex == 1,
                            'c-2d__page-number--inactive': currentIndex != 1,
                        }"
                    ></span>
                </div>
                <button
                    v-show="mobile"
                    v-on:click="goNext()"
                    class="o-shop-item__icon o-shop-item__icon--prev"
                ></button>
                <button
                    v-show="mobile"
                    v-on:click="goPrev()"
                    class="o-shop-item__icon o-shop-item__icon--next"
                ></button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["parentcurrency"],
    metaInfo: {
        title: "Shop",
        meta: [
            {
                name: "description",
                content: "The Artful Dodgers Ltd Shop. Treat yourself! ",
            },
            { property: "og:title", content: "Shop | Artful Dodgers Ltd" },
            { property: "og:site_name", content: "Artful Dodgers" },
            {
                property: "og:description",
                content: "The Artful Dodgers Ltd Shop. Treat yourself!",
            },
            { property: "og:type", content: "shop" },
            { property: "og:url", content: "https://artfuldodgers.co.nz/shop" },
            {
                property: "og:image",
                content:
                    "https://artfuldodgers.co.nz/assets/img/ad-trixy-ring.png",
            },
        ],
    },
    data: function () {
        return {
            shopLoaded: false,
            mobile: false,
            metalClass: "c-silder-filter__input--gold",
            metal: { text: "Gold", value: 0 },
            rings: [],
            initVideosLoaded: 0,
            currentIndex: 0,
            videoShowing: false,
            vidScale: 1,
            metals: [
                { text: "Gold", value: 0 },
                { text: "Silver", value: 2 },
                { text: "Rose gold", value: 4 },
                { text: "White gold", value: 6 },
            ],
        };
    },
    computed: {
        currencyChange() {
            return this.$store.state.currency;
        },
        currency() {
            var self = this;
            if (
                this.rings &&
                (this.rings.updateIndex > 0 ||
                    this.rings.updateIndex == undefined)
            ) {
                console.log(currencyChange);
                var newPrice = currencyChange;
                this.rings.forEach(function (ring) {
                    ring.variations.forEach(function (variation) {
                        variation.price.forEach(function (price) {
                            if (price.currency == currencyChange) {
                                variation.setPrice = price;
                            }
                        });
                    });
                });
            }
            return this.$store.state.currency;
        },
    },
    watch: {
        currencyChange: function () {},
        metal: {
            handler: function (metal) {
                var self = this;
                for (var i = 0; i < this.rings.length; i++) {
                    this.rings[i].variationIndex = metal.value;

                    var newPrice =
                        self.rings[i].variations[metal.value].price[
                            self.$store.state.currency
                        ].amount / 100;

                    if (i == 0) {
                        var ring1 = self.rings[0];
                        var current1 = { count: self.rings[0].setPrice };

                        TweenMax.to(current1, 1, {
                            count: newPrice,
                            onUpdate: function () {
                                ring1.setPrice = Math.ceil(current1.count);
                            },
                            ease: Power1.easeInOut,
                        });
                    } else if (i == 1) {
                        var ring2 = self.rings[1];
                        var current2 = { count: self.rings[1].setPrice };

                        TweenMax.to(current2, 1, {
                            count: newPrice,
                            onUpdate: function () {
                                ring2.setPrice = Math.ceil(current2.count);
                            },
                            ease: Power1.easeInOut,
                        });
                    } else if (i == 2) {
                        var ring3 = self.rings[2];
                        var current3 = { count: self.rings[2].setPrice };

                        TweenMax.to(current3, 1, {
                            count: newPrice,
                            onUpdate: function () {
                                ring3.setPrice = Math.ceil(current3.count);
                            },
                            ease: Power1.easeInOut,
                        });
                    }
                }
                setTimeout(function () {
                    var middleVideo = $(".js-video-started")[1];
                    middleVideo.pause();
                    const playPromise = middleVideo.play();
                    if (playPromise !== null) {
                        playPromise.catch(() => {
                            // console.log("no click");
                        });
                    }
                }, 100);
            },
        },
        initVideosLoaded: function (val) {
            var self = this;
            if (val == 3 && self.$parent.initLoad) {
                self.shopLoad();
            } else if (val == 3) {
                var checkExist = setInterval(function () {
                    if (self.$parent.initLoad) {
                        clearInterval(checkExist);
                        self.shopLoad();
                    }
                }, 100); // check every 100ms
            }
            if (val == 2) {
                self.rings.forEach(function (ring) {
                    ring.variations.forEach(function (variation) {
                        variation.videoSrc = variation.video;
                    });
                });
            }
        },
    },
    methods: {
        lazyLoadSrc: function (srcUrl, firstVideo) {
            if (firstVideo) {
                return srcUrl;
            } else {
                return "";
            }
        },
        checkPreconnect: function (ringIndex, varIndex) {
            if (ringIndex == varIndex) {
                return "prefetch";
            }
            return "";
        },
        setUpTouch: function () {
            var self = this;
            document.addEventListener("touchstart", handleTouchStart, false, {
                passive: true,
            });
            document.addEventListener("touchmove", handleTouchMove, false, {
                passive: true,
            });

            var xDown = null;
            var yDown = null;

            function getTouches(evt) {
                return (
                    evt.touches || evt.originalEvent.touches // browser API
                ); // jQuery
            }

            function handleTouchStart(evt) {
                const firstTouch = getTouches(evt)[0];
                xDown = firstTouch.clientX;
                yDown = firstTouch.clientY;
            }

            function handleTouchMove(evt) {
                if (!xDown || !yDown) {
                    return;
                }

                var xUp = evt.touches[0].clientX;
                var yUp = evt.touches[0].clientY;

                var xDiff = xDown - xUp;
                var yDiff = yDown - yUp;

                if (Math.abs(xDiff) > Math.abs(yDiff)) {
                    /*most significant*/
                    if (xDiff > 0) {
                        /* left swipe */

                        self.goPrev();
                    } else {
                        self.goNext();
                    }
                } else {
                    if (yDiff > 0) {
                        /* up swipe */
                    } else {
                        /* down swipe */
                    }
                }
                /* reset values */
                xDown = null;
                yDown = null;
            }
        },
        goPrev: function () {
            var self = this;
            var middleVideo = $(".js-video-started")[1];
            middleVideo.pause();

            TweenMax.to($(".o-shop-items__item"), 0.2, {
                x: -30,
                opacity: 0,
                ease: Power1.easeIn,
            });
            setTimeout(function () {
                var k = self.rings.splice(0, 1);
                self.rings.push(k[0]);
                TweenMax.fromTo(
                    $(".o-shop-items__item"),
                    0.3,
                    { x: 30, opacity: 0 },
                    { x: 0, opacity: 1, ease: Power1.easeOut }
                );

                var middleVideo = $(".js-video-started")[2];
                const playPromise = middleVideo.play();
                if (playPromise !== null) {
                    playPromise.catch(() => {
                        // console.log("no click");
                    });
                }
                if (self.currentIndex == 0) {
                    self.currentIndex = 2;
                } else {
                    self.currentIndex--;
                }
            }, 300);
        },
        goNext: function () {
            var self = this;
            var middleVideo = $(".js-video-started")[1];
            middleVideo.pause();

            TweenMax.to($(".o-shop-items__item"), 0.2, {
                x: 30,
                opacity: 0,
                ease: Power1.easeIn,
            });
            setTimeout(function () {
                var k = self.rings[2];
                self.rings = self.rings.splice(0, 2);
                self.rings.unshift(k);
                TweenMax.fromTo(
                    $(".o-shop-items__item"),
                    0.3,
                    { x: -30, opacity: 0 },
                    { x: 0, opacity: 1, ease: Power1.easeOut }
                );

                var middleVideo = $(".js-video-started")[0];
                const playPromise = middleVideo.play();
                if (playPromise !== null) {
                    playPromise.catch(() => {
                        // console.log("no click");
                    });
                }
                if (self.currentIndex == 2) {
                    self.currentIndex = 0;
                } else {
                    self.currentIndex++;
                }
            }, 300);
        },
        shopLoad: function () {
            var self = this;
            setTimeout(function () {
                TweenMax.to($(".c-loading__line-text"), 0.2, {
                    x: 200,
                    opacity: 0,
                    ease: Power2.easeIn,
                });
            }, 100);
            $(".c-loading__line").css("transform-origin", "right");
            TweenMax.to($(".c-loading__line"), 0.5, {
                scaleX: 0,
                ease: Power1.easeOut,
            });
            setTimeout(function () {
                $(".c-loading__line").css("transform-origin", "left");
                // console.log();
                // $('.c-loading__line-container').removeClass("c-loading-line--visible")
                self.$parent.loadingLine = false;
            }, 600);
            var loadingBlocks = $(".c-loading-block");

            TweenMax.staggerTo(
                loadingBlocks,
                0.4,
                { scaleX: 1, ease: Power2.easeInOut },
                0.04
            );

            //footer
            var footerBar = $("#socialBar");
            TweenMax.to(footerBar, 0.1, { opacity: 0, scaleX: 0 });
            setTimeout(function () {
                TweenMax.to(footerBar, 0, { opacity: 1 });
                TweenMax.to(footerBar, 1.3, {
                    scaleX: 1,
                    ease: Power3.easeOut,
                });
            }, 100);

            setTimeout(function () {
                var footerBar = $("#socialBar");
                $(".c-shop__video").fadeTo(0, 1);
                TweenMax.staggerTo(
                    loadingBlocks,
                    1.4,
                    { scaleY: 0, ease: Power3.easeOut },
                    0.02
                );
                TweenMax.staggerTo(
                    $(".c-shop__video"),
                    1.6,
                    { x: 0, ease: Power4.easeOut },
                    0.04
                );
                setTimeout(function () {
                    self.videoShowing = true;
                }, 1200);
            }, 400);
            this.shopLoaded = true;
        },
        shopItemHover: function (elId, varId) {
            if (!this.mobile) {
                var item = document.getElementById(elId);
                item.classList.add("o-shop-item--hover");

                var media = $("#video-" + varId)[0];

                const playPromise = media.play();
                if (playPromise !== null) {
                    playPromise.catch(() => {
                        // console.log("no click");
                    });
                }
            }
        },
        shopItemHoverRemove: function (elId, varId) {
            if (!this.mobile) {
                var item = document.getElementById(elId);
                item.classList.remove("o-shop-item--hover");

                $("#video-" + varId)[0].pause();
            }
        },
        goToDetails: function (event, ring) {
            event.preventDefault();
            this.$store.commit("updateRing", ring);
            this.$router.push("/product/" + ring.url);
        },
        getProducts: function () {
            var self = this;

            AWS.config.region = "us-west-2"; // Region
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                IdentityPoolId:
                    "us-west-2:4d64ca9e-fd06-4129-9516-2c7b50c73473",
            });

            var s3 = new AWS.S3({ params: { Bucket: "artfuldodgersrings" } });
            var params = {
                Bucket: "artfuldodgersrings",
                Key: "example.JSON",
            };
            var ringsFromServer;
            s3.getObject(params, function (err, data) {
                if (err) {
                    console.log(err, err.stack);
                } else {
                    ringsFromServer = JSON.parse(data.Body).rings;
                    ringsFromServer.forEach(function (ring) {
                        ring.variationIndex = 0;
                        ring.variations.forEach(function (variation, index) {
                            //Here we would look for the local currency.
                            variation.setPrice =
                                variation.price[self.$store.state.currency];
                            variation.imageIndex = 0;

                            if (index == 0) {
                                ring.setPrice = variation.setPrice.amount / 100;
                                variation.videoSrc = variation.video;
                            } else {
                                variation.videoSrc = "";
                            }
                        });
                    });
                    self.rings = ringsFromServer;
                }
            });
            this.rings = ringsFromServer;
        },
    },
    // mounted: function() {
    //     this.$nextTick(function () {
    //         var figure = $(".video").hover( hoverVideo, hideVideo );

    //         function hoverVideo(e) {
    //             $('video', this).get(0).play();
    //         }

    //         function hideVideo(e) {
    //             $('video', this).get(0).pause();
    //         }
    //     })
    // },
    created: function () {
        var self = this;

        this.getProducts();
        var checkExist = setInterval(function () {
            if ($(".js-video-started").length > 2) {
                clearInterval(checkExist);
                $(".js-video-started").each(function (i, e) {
                    e.addEventListener(
                        "loadeddata",
                        function () {
                            self.initVideosLoaded++;
                        },
                        false
                    );
                    setTimeout(function () {
                        self.initVideosLoaded = 3;
                    }, 9000);
                });
                //MOBILE
                var isMobile = window.matchMedia("(max-width: 764px)");
                if (isMobile.matches) {
                    self.vidScale = 1.2;
                    if (window.matchMedia("(max-width: 764px)").matches) {
                        self.vidScale = 1.3;
                    }
                    self.mobile = true;
                    //HANDLE VIDEO
                    var waitToLoadVid = setInterval(function () {
                        var middleVideo = $(".js-video-started")[1];
                        if (middleVideo != undefined) {
                            var playPromise = middleVideo.play();
                            // In browsers that don’t yet support this functionality,
                            if (playPromise !== undefined) {
                                playPromise
                                    .then(function () {
                                        // Automatic playback started!
                                    })
                                    .catch(function (error) {
                                        console.log("error ", error);
                                        // Automatic playback failed.
                                        // Show a UI element to let the user manually start playback.
                                    });
                            }
                            clearInterval(waitToLoadVid);
                        }
                    }, 100);
                }
                self.setUpTouch();
            }
        }, 100); // check every 100ms
    },
};
</script>



// WEBPACK FOOTER //
// Shop.vue?24928b8d